/**
 * Oturum deposu temizliği.
 *
 * Çıkışın İKİ yolu var ve ikisi de buradan geçer:
 *   1. Kullanıcının kendi çıkışı  → `AuthContext.logout()`
 *   2. Sunucudan 401 gelmesi      → `services/http.ts` yanıt kesicisi
 *
 * Neden iki depo birden: tarayıcı deposunda tutulan her şey o kullanıcıya ait.
 * `localStorage` yalnız kimlik bilgisi tutuyor (`user`, `user_name`, `role`,
 * `is_logged_in`); `sessionStorage` ise liste filtrelerini ve sayfa numaralarını
 * (`orderList_filters`, `customerList_filters`, `productList_*`,
 * `productListGorsel_*`, `materialList_*`). Eskiden yalnız kimlik siliniyordu,
 * filtreler kalıyordu: aynı tarayıcıda ikinci kullanıcı giriş yaptığında
 * öncekinin arama metnini ve filtrelerini görüyordu.
 *
 * Anahtarları tek tek silmek yerine iki depo da tamamen temizleniyor — yeni bir
 * filtre anahtarı eklendiğinde burayı güncellemek gerekmesin diye. Bu yüzden
 * çıkıştan SONRA yaşaması gereken bir tercih (tema vb.) eklenecekse tarayıcı
 * deposu doğru yer değildir; önce bu notu güncelle.
 */
export const clearUserSession = (): void => {
  // Depo erişimi bazı bağlamlarda (gizli sekme, site verisi kapalı) hata
  // fırlatabilir. Çıkışın kendisi bu yüzden yarım kalmasın.
  try {
    localStorage.clear();
  } catch {
    /* yok say */
  }
  try {
    sessionStorage.clear();
  } catch {
    /* yok say */
  }
};
